import React from 'react';
import fr from 'facet-rest';
import {
  useSignUpFlowContext,
} from 'Views/Onboarding/OnboardingHasUser/OnboardingHasUserContent/OnboardingHasUserContentRouter/SignUpFlow/SignUpFlowContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import eventSubTypes from 'EventTracking/consts/eventSubTypes';

function init() {
  return {
    isLoading: false,
    loadingError: null,
    showDeclineScreen: false,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'acceptStarted': {
      return {
        ...state,
        isLoading: true,
        loadingError: null,
      };
    }
    case 'acceptSucceeded': {
      return {
        ...state,
        isLoading: false,
        loadingError: null,
      };
    }
    case 'acceptFailed': {
      return {
        ...state,
        isLoading: false,
        loadingError: action.acceptError,
      };
    }
    case 'navigateToDeclined': {
      return {
        ...state,
        showDeclineScreen: true,
        random: Math.random(),
      };
    }
    case 'navigateToAgreement': {
      return {
        ...state,
        showDeclineScreen: false,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export default function useWebsiteAgreement() {
  const { activeStep, refreshSignUpStepsCollection } = useSignUpFlowContext();
  const [state, dispatch] = React.useReducer(reducer, null, init);
  const { logStandardizedEvent } = useEventTrackingLogEvent({
    nodeName: 'Website Agreement',
    isPageView: true,
  });

  async function handleAgree() {
    dispatch({ type: 'acceptStarted' });

    try {
      const acceptRequest = {
        type: 'agreeToWebSiteAccess',
        attributes: {
          agreed: true,
        },
      };

      await activeStep.relationship(fr.relationships.relatedTask.name)
        .link('related')
        .Put(acceptRequest, { deprecatedAllowAlterOfRelation: true });

      await refreshSignUpStepsCollection();

      logStandardizedEvent(categories.digitalOnboarding, eventTypes.completeStep, eventSubTypes.success, { eventProperties: { stepName: 'website agreement' } });

      dispatch({ type: 'acceptSucceeded' });
    } catch (err) {
      dispatch({ type: 'acceptFailed', acceptError: err });
    }
  }

  function navigateToDeclined() {
    dispatch({ type: 'navigateToDeclined' });
  }

  function navigateToAgreement() {
    dispatch({ type: 'navigateToAgreement' });
  }

  return {
    isSavingResponse: state.isLoading,
    savingResponseError: state.loadingError,
    handleAgree,
    showDeclineScreen: state.showDeclineScreen,
    navigateToDeclined,
    navigateToAgreement,
  };
}
